<template>
  <div class="bg-network" aria-hidden="true">
    <svg viewBox="0 0 1600 1000" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="netLine" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#83e6ff" stop-opacity="0"/>
            <stop offset="50%" stop-color="#83e6ff" stop-opacity="0.6"/>
            <stop offset="100%" stop-color="#83e6ff" stop-opacity="0"/>
          </linearGradient>
          <radialGradient id="particleGrad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="#cdf3ff" stop-opacity="1"/>
            <stop offset="55%" stop-color="#83e6ff" stop-opacity=".85"/>
            <stop offset="100%" stop-color="#83e6ff" stop-opacity="0"/>
          </radialGradient>
                <path id="p1" d="M630.0,884.0 L730.0,918.0"/>
          <path id="p2" d="M1149.0,536.0 L1238.0,428.0"/>
          <path id="p3" d="M1301.0,609.0 L1534.0,515.0"/>
          <path id="p4" d="M1238.0,428.0 L1083.0,531.0"/>
          <path id="p5" d="M375.0,597.0 L439.0,564.0"/>
          <path id="p6" d="M998.0,63.0 L816.0,64.0"/>
          <path id="p7" d="M1124.0,333.0 L1238.0,428.0"/>
          <path id="p8" d="M998.0,63.0 L1100.0,69.0"/>
          <path id="p9" d="M844.0,944.0 L730.0,918.0"/>
          <path id="p10" d="M816.0,64.0 L966.0,191.0"/>
          <path id="p11" d="M998.0,63.0 L966.0,191.0"/>
          <path id="p12" d="M1149.0,536.0 L1083.0,531.0"/>
          <path id="p13" d="M1301.0,609.0 L1298.0,742.0"/>
          <path id="p14" d="M375.0,597.0 L194.0,289.0"/>
          <path id="p15" d="M361.0,915.0 L630.0,884.0"/>
          <path id="p16" d="M1100.0,69.0 L966.0,191.0"/>
          <path id="p17" d="M1124.0,333.0 L1083.0,531.0"/>
          <path id="p18" d="M194.0,289.0 L358.0,286.0"/>
          <path id="p19" d="M1065.0,847.0 L816.0,64.0"/>
          <path id="p20" d="M1149.0,536.0 L1301.0,609.0"/>
        </defs>
    
        <g stroke="url(#netLine)" stroke-width=".7" fill="none" stroke-opacity=".6">
                <line id="p1" class="nline rev" x1="630.0" y1="884.0" x2="730.0" y2="918.0"/>
          <line id="p2" class="nline" x1="1149.0" y1="536.0" x2="1238.0" y2="428.0"/>
          <line id="p3" class="nline rev" x1="1301.0" y1="609.0" x2="1534.0" y2="515.0"/>
          <line id="p4" class="nline" x1="1238.0" y1="428.0" x2="1083.0" y2="531.0"/>
          <line id="p5" class="nline rev" x1="375.0" y1="597.0" x2="439.0" y2="564.0"/>
          <line id="p6" class="nline" x1="998.0" y1="63.0" x2="816.0" y2="64.0"/>
          <line id="p7" class="nline rev" x1="1124.0" y1="333.0" x2="1238.0" y2="428.0"/>
          <line id="p8" class="nline" x1="998.0" y1="63.0" x2="1100.0" y2="69.0"/>
          <line id="p9" class="nline rev" x1="844.0" y1="944.0" x2="730.0" y2="918.0"/>
          <line id="p10" class="nline" x1="816.0" y1="64.0" x2="966.0" y2="191.0"/>
          <line id="p11" class="nline rev" x1="998.0" y1="63.0" x2="966.0" y2="191.0"/>
          <line id="p12" class="nline" x1="1149.0" y1="536.0" x2="1083.0" y2="531.0"/>
          <line id="p13" class="nline rev" x1="1301.0" y1="609.0" x2="1298.0" y2="742.0"/>
          <line id="p14" class="nline" x1="375.0" y1="597.0" x2="194.0" y2="289.0"/>
          <line id="p15" class="nline rev" x1="361.0" y1="915.0" x2="630.0" y2="884.0"/>
          <line id="p16" class="nline" x1="1100.0" y1="69.0" x2="966.0" y2="191.0"/>
          <line id="p17" class="nline rev" x1="1124.0" y1="333.0" x2="1083.0" y2="531.0"/>
          <line id="p18" class="nline" x1="194.0" y1="289.0" x2="358.0" y2="286.0"/>
          <line id="p19" class="nline rev" x1="1065.0" y1="847.0" x2="816.0" y2="64.0"/>
          <line id="p20" class="nline" x1="1149.0" y1="536.0" x2="1301.0" y2="609.0"/>
        </g>
    
        <g class="ndot nd-a">
          <circle cx="998.0" cy="63.0" r="1.6"/>
          <circle cx="816.0" cy="64.0" r="1.6"/>
          <circle cx="375.0" cy="597.0" r="1.6"/>
          <circle cx="1124.0" cy="333.0" r="1.7"/>
          <circle cx="1149.0" cy="536.0" r="1.7"/>
          <circle cx="1301.0" cy="609.0" r="1.8"/>
          <circle cx="1100.0" cy="69.0" r="1.7"/>
          <circle cx="194.0" cy="289.0" r="1.7"/>
          <circle cx="966.0" cy="191.0" r="1.7"/>
          <circle cx="630.0" cy="884.0" r="1.5"/>
          <circle cx="1238.0" cy="428.0" r="1.7"/>
          <circle cx="1083.0" cy="531.0" r="1.7"/>
          <circle cx="730.0" cy="918.0" r="1.5"/>
        </g>
        <g class="ndot nd-b">
          <circle cx="1065.0" cy="847.0" r="1.1"/>
          <circle cx="358.0" cy="286.0" r="1.1"/>
          <circle cx="1298.0" cy="742.0" r="1.2"/>
          <circle cx="361.0" cy="915.0" r="1.3"/>
          <circle cx="439.0" cy="564.0" r="1.2"/>
          <circle cx="1534.0" cy="515.0" r="1.3"/>
          <circle cx="844.0" cy="944.0" r="1.3"/>
        </g>
        <g class="ndot nd-c">
          <circle cx="187.0" cy="820.0" r="0.7"/>
          <circle cx="1544.0" cy="629.0" r="0.7"/>
        </g>
    
        <g>
                <circle class="particle" r="2.2" fill="url(#particleGrad)"><animateMotion dur="4.9s" repeatCount="indefinite" begin="-2.7s"><mpath href="#p1"/></animateMotion></circle>
          <circle class="particle" r="1.6" fill="url(#particleGrad)"><animateMotion dur="5.4s" repeatCount="indefinite" begin="-2.7s"><mpath href="#p1"/></animateMotion></circle>
          <circle class="particle" r="2.0" fill="url(#particleGrad)"><animateMotion dur="4.1s" repeatCount="indefinite" begin="-2.1s"><mpath href="#p2"/></animateMotion></circle>
          <circle class="particle" r="1.8" fill="url(#particleGrad)"><animateMotion dur="5.9s" repeatCount="indefinite" begin="-0.6s"><mpath href="#p3"/></animateMotion></circle>
          <circle class="particle" r="2.0" fill="url(#particleGrad)"><animateMotion dur="3.8s" repeatCount="indefinite" begin="-3.1s"><mpath href="#p4"/></animateMotion></circle>
          <circle class="particle" r="1.8" fill="url(#particleGrad)"><animateMotion dur="4.1s" repeatCount="indefinite" begin="-4.0s"><mpath href="#p4"/></animateMotion></circle>
          <circle class="particle" r="1.7" fill="url(#particleGrad)"><animateMotion dur="5.5s" repeatCount="indefinite" begin="-3.4s"><mpath href="#p5"/></animateMotion></circle>
          <circle class="particle" r="1.6" fill="url(#particleGrad)"><animateMotion dur="3.5s" repeatCount="indefinite" begin="-1.8s"><mpath href="#p6"/></animateMotion></circle>
          <circle class="particle" r="1.6" fill="url(#particleGrad)"><animateMotion dur="4.1s" repeatCount="indefinite" begin="-1.0s"><mpath href="#p7"/></animateMotion></circle>
          <circle class="particle" r="1.7" fill="url(#particleGrad)"><animateMotion dur="5.4s" repeatCount="indefinite" begin="-2.4s"><mpath href="#p7"/></animateMotion></circle>
          <circle class="particle" r="1.9" fill="url(#particleGrad)"><animateMotion dur="5.1s" repeatCount="indefinite" begin="-3.3s"><mpath href="#p8"/></animateMotion></circle>
          <circle class="particle" r="1.8" fill="url(#particleGrad)"><animateMotion dur="5.5s" repeatCount="indefinite" begin="-2.5s"><mpath href="#p9"/></animateMotion></circle>
          <circle class="particle" r="2.1" fill="url(#particleGrad)"><animateMotion dur="6.5s" repeatCount="indefinite" begin="-6.5s"><mpath href="#p10"/></animateMotion></circle>
          <circle class="particle" r="1.4" fill="url(#particleGrad)"><animateMotion dur="6.1s" repeatCount="indefinite" begin="-1.9s"><mpath href="#p10"/></animateMotion></circle>
          <circle class="particle" r="2.1" fill="url(#particleGrad)"><animateMotion dur="4.4s" repeatCount="indefinite" begin="-0.3s"><mpath href="#p11"/></animateMotion></circle>
          <circle class="particle" r="1.8" fill="url(#particleGrad)"><animateMotion dur="4.7s" repeatCount="indefinite" begin="-4.0s"><mpath href="#p12"/></animateMotion></circle>
          <circle class="particle" r="1.6" fill="url(#particleGrad)"><animateMotion dur="6.4s" repeatCount="indefinite" begin="-5.4s"><mpath href="#p13"/></animateMotion></circle>
          <circle class="particle" r="1.5" fill="url(#particleGrad)"><animateMotion dur="4.6s" repeatCount="indefinite" begin="-4.2s"><mpath href="#p13"/></animateMotion></circle>
          <circle class="particle" r="1.6" fill="url(#particleGrad)"><animateMotion dur="6.4s" repeatCount="indefinite" begin="-2.5s"><mpath href="#p14"/></animateMotion></circle>
          <circle class="particle" r="1.8" fill="url(#particleGrad)"><animateMotion dur="5.4s" repeatCount="indefinite" begin="-4.2s"><mpath href="#p15"/></animateMotion></circle>
          <circle class="particle" r="2.2" fill="url(#particleGrad)"><animateMotion dur="3.8s" repeatCount="indefinite" begin="-1.3s"><mpath href="#p16"/></animateMotion></circle>
          <circle class="particle" r="1.4" fill="url(#particleGrad)"><animateMotion dur="6.3s" repeatCount="indefinite" begin="-0.7s"><mpath href="#p16"/></animateMotion></circle>
          <circle class="particle" r="2.1" fill="url(#particleGrad)"><animateMotion dur="3.8s" repeatCount="indefinite" begin="-0.2s"><mpath href="#p17"/></animateMotion></circle>
          <circle class="particle" r="1.9" fill="url(#particleGrad)"><animateMotion dur="4.0s" repeatCount="indefinite" begin="-2.2s"><mpath href="#p18"/></animateMotion></circle>
          <circle class="particle" r="1.7" fill="url(#particleGrad)"><animateMotion dur="4.1s" repeatCount="indefinite" begin="-3.0s"><mpath href="#p19"/></animateMotion></circle>
          <circle class="particle" r="1.5" fill="url(#particleGrad)"><animateMotion dur="5.9s" repeatCount="indefinite" begin="-0.7s"><mpath href="#p19"/></animateMotion></circle>
          <circle class="particle" r="2.2" fill="url(#particleGrad)"><animateMotion dur="4.1s" repeatCount="indefinite" begin="-1.1s"><mpath href="#p20"/></animateMotion></circle>
        </g>
      </svg>
  </div>
</template>

<script>
export default {
  name: 'NetworkBackground'
};
</script>

<style lang="less" scoped>
.bg-network {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0.75;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  .ndot circle {
    fill: #83e6ff;
  }
  .ndot.nd-a circle {
    animation: ndBlink 2.4s ease-in-out infinite, ndBreathe 4s ease-in-out infinite;
  }
  .ndot.nd-b circle {
    animation: ndBlink 3s ease-in-out infinite 0.6s, ndBreathe 4.6s ease-in-out infinite -1.5s;
  }
  .ndot.nd-c circle {
    animation: ndBlink 3.6s ease-in-out infinite 1.2s, ndBreathe 5.2s ease-in-out infinite -3s;
  }
  .nline {
    stroke-dasharray: 2 4;
    animation: lineFlow 10s linear infinite;
  }
  .nline.rev {
    animation-direction: reverse;
  }
  .particle {
    filter: drop-shadow(0 0 2.5px #83e6ff);
  }
}

@keyframes ndBlink {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
@keyframes ndBreathe {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}
@keyframes lineFlow {
  to { stroke-dashoffset: -200; }
}

@media (prefers-reduced-motion: reduce) {
  .bg-network {
    opacity: 0.3;
  }
  .bg-network .nline,
  .bg-network .ndot circle,
  .bg-network .particle {
    animation: none;
  }
}
</style>
